import React from 'react';
import { TabElementLabel, TabHeader, TabRow } from '../Tabs-styled';
import { DropdownLUXE } from '../../UIHelpersLUXE/Dropdown/DropdownLUXE';
import { IStoneGroup } from '../../../../sharedInterfaces';
import { GridMenuOptionsContainer } from '../../UIHelpersLUXE/GridMenu/GridMenu-styled';
import { GridMenuItem } from '../../UIHelpersLUXE/GridMenu/GridMenuItem';
import { isLowHeight, isMobile } from '../../../shared/UIHelpers/Functions/Functions';
import { StoneGroupSection, StonesSectionHeaderBottomText, StonesSectionHeaderContainer, StonesSectionHeaderLeftSide, StonesSectionHeaderTopText, StonesTabContainer } from './StonesLUXE-styled';


interface Props {
  stoneCut:'Brilliant'|'Princess'|'Baguette',
  stoneCount:number,
  stoneCountOptions:number[],
  onStoneCountChange:(value:number)=>void
  stoneSize:number,
  stoneSizeOptions:number[],
  onStoneSizeChange:(value:number)=>void,
  stoneGroups:IStoneGroup[],
  onStoneGroupChange:(value:IStoneGroup)=>void,
  assetURI:string,
  mobile:boolean,
  menuHeight:number,
  menuScaleFactor:number
}

interface State {
}


export default class Stones extends React.Component<Props,State> {
  constructor(props: Props) {
    super(props);
  }

  public onParameterChange = (groupName:string, param:string, value:any) => {
    const { stoneGroups } = this.props;
    const editedStoneGroup = stoneGroups.find((el) => el.name === groupName);

    this.props.onStoneGroupChange({
      ...editedStoneGroup,
      [param]: value,
    });
  };

  public render = () => {
    const {
      stoneCut,
      stoneGroups,
      assetURI,
      mobile,
      menuHeight,
      menuScaleFactor
    } = this.props;

    //FIXME: Stone sizes in carat (see StoneSizeSlider.tsx)
    let stoneSize = { value: "0", label: "--" };
    const stoneSizeOptions = this.props.stoneSizeOptions.map((option) => { return { value: option.toString(), label: `${option.toString()}MM` } });
    const onStoneSizeChange = (value) => { this.props.onStoneSizeChange(Number(value)) };
    if (this.props.stoneSize && stoneSizeOptions.length > 0 && this.props.stoneCount > 0) stoneSize = { value: this.props.stoneSize.toString(), label: `${this.props.stoneSize.toString()}MM` };

    const stoneCount = { value: this.props.stoneCount.toString(), label: this.props.stoneCount.toString() };
    const stoneCountOptions = this.props.stoneCountOptions.map((option) => { return { value: option.toString(), label: option.toString() } });
    const onStoneCountChange = (value) => { this.props.onStoneCountChange(Number(value)) };

    return (
      <StonesTabContainer mobile={mobile} menuHeight={menuHeight} menuScaleFactor={menuScaleFactor}>
        <TabHeader>ADD STONES</TabHeader>

        {stoneGroups.map((stoneGroup) => {
          return (
            <StoneGroupSection key={stoneGroup.name}>
              <StonesSectionHeaderContainer>
                <StonesSectionHeaderLeftSide>
                  <StonesSectionHeaderTopText>{stoneGroup.name}</StonesSectionHeaderTopText>
                </StonesSectionHeaderLeftSide>
              </StonesSectionHeaderContainer> 
              <GridMenuOptionsContainer key={stoneGroup.name}>
                {stoneGroup.stoneOptions.map(stoneOption =>
                  <GridMenuItem
                    option={stoneOption}
                    imgName={stoneOption}
                    assetURI={`${assetURI}/images/stones/`}
                    isSelected={stoneOption === stoneGroup.stone}
                    onClick={(value) => this.onParameterChange(stoneGroup.name, 'stone', value)}
                    key={`${stoneGroup.name}-${stoneOption}`}
                    isMobile={isMobile()}
                    isLowHeight={isLowHeight()}
                  />
                )}
              </GridMenuOptionsContainer>
            </StoneGroupSection>
          )
        })}

        <TabRow>
          <TabElementLabel>Size</TabElementLabel>
          <TabElementLabel>Count</TabElementLabel>
        </TabRow>
        <TabRow>
          <DropdownLUXE
            options={stoneSizeOptions}
            defaultOption={stoneSize}
            onChange={onStoneSizeChange}
            disabled={stoneSizeOptions.length <= 1}
          />
          <DropdownLUXE
            options={stoneCountOptions}
            defaultOption={stoneCount}
            onChange={onStoneCountChange}
            disabled={stoneCountOptions.length <= 1}
          />
        </TabRow>
      </StonesTabContainer>
    )
  }
}